
import React, { useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './About.css';
import NavBarTop from '../components/NavBarTop';

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="mobile-page-container">
            <NavBarTop title="About Physio Directory" />

            {/* Hero Content */}
            <div className="container-fluid px-3 pt-4 section-fade-in">
                {/* Removed white card as per request */}
                
                {/* Mission & Vision */}
                <div className="row g-3 mb-4">
                    <div className="col-12">
                        <div className="card h-100 border-0 shadow-sm rounded-4 p-4 bg-white">
                            <div className="d-flex align-items-center mb-3">
                                <div className="rounded-circle bg-primary-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'50px', height:'50px'}}>
                                    <i className="bi bi-bullseye text-primary fs-4"></i>
                                </div>
                                <h5 className="fw-bold mb-0">Our Mission</h5>
                            </div>
                            <p className="text-muted small mb-0">
                                To bridge the gap between patients seeking quality physiotherapy care and certified healthcare providers, 
                                making healthcare accessible, transparent, and convenient for everyone. We strive to create a trusted 
                                platform where patients can easily find and connect with verified professionals.
                            </p>
                        </div>
                    </div>
                    <div className="col-12">
                         <div className="card h-100 border-0 shadow-sm rounded-4 p-4 bg-white">
                            <div className="d-flex align-items-center mb-3">
                                <div className="rounded-circle bg-info-subtle p-2 me-3 d-flex align-items-center justify-content-center" style={{width:'50px', height:'50px'}}>
                                    <i className="bi bi-eye text-info fs-4"></i>
                                </div>
                                <h5 className="fw-bold mb-0">Our Vision</h5>
                            </div>
                            <p className="text-muted small mb-0">
                                To become the leading platform for physiotherapy services, recognized for our commitment to quality, 
                                transparency, and patient care. We envision a future where finding the right healthcare provider is 
                                simple, fast, and reliable for everyone.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Who We Are */}
                 <div className="card border-0 shadow-sm rounded-4 p-4 mb-4 bg-white">
                    <h5 className="fw-bold mb-3">Who We Are</h5>
                    <p className="text-muted small mb-3">
                        Physio Directory is a comprehensive digital platform that connects patients with verified 
                        physiotherapists, clinics, and rehabilitation centers across the country. Founded with a mission to make 
                        quality healthcare accessible, we provide a trusted marketplace where patients can discover, evaluate, and 
                        connect with qualified healthcare professionals.
                    </p>
                    <p className="text-muted small mb-0">
                        Our platform features certified professionals who have been thoroughly verified by our team, ensuring that 
                        patients receive the best possible care from qualified practitioners. We believe in transparency, quality, 
                        and putting patient needs first.
                    </p>
                </div>

                {/* Values */}
                <h5 className="fw-bold mb-3 ps-1">Our Core Values</h5>
                <div className="row g-3 mb-4">
                    {[
                        { icon: 'bi-shield-check', title: 'Trust & Verification', desc: 'Strict verification of credentials and qualifications.' },
                        { icon: 'bi-heart', title: 'Patient-Centric', desc: 'We prioritize patient needs, safety, and satisfaction.' },
                        { icon: 'bi-eye', title: 'Transparency', desc: 'Clear and upfront information from credentials to pricing.' },
                        { icon: 'bi-star', title: 'Quality First', desc: 'High standards with qualified, experienced professionals.' },
                        { icon: 'bi-people', title: 'Accessibility', desc: 'Quality healthcare for everyone, everywhere.' },
                        { icon: 'bi-lightning-charge', title: 'Innovation', desc: 'Continuously improving via new features and technology.' }
                    ].map((val, idx) => (
                         <div className="col-6" key={idx}>
                            <div className="card h-100 border-0 shadow-sm rounded-4 p-3 bg-white text-center">
                                <div className="mx-auto mb-2 text-primary">
                                    <i className={`bi ${val.icon} fs-3`}></i>
                                </div>
                                <h6 className="fw-bold mb-2 small">{val.title}</h6>
                                <p className="text-muted mb-0" style={{fontSize: '0.7rem'}}>{val.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                 {/* Timeline */}
                 <div className="card border-0 shadow-sm rounded-4 p-4 mb-4 bg-white">
                     <h5 className="fw-bold mb-4 text-center">Our Journey</h5>
                     <div className="timeline ps-2">
                        {[
                            { year: '2021', title: 'Starting', desc: 'Founded with a vision to make quality physiotherapy accessible.' },
                            { year: '2023', title: 'Platform Launch', desc: 'Launched with verified providers.' },
                            { year: '2024', title: 'Expansion', desc: 'Expanded to multiple cities with advanced features.' },
                            { year: '2025', title: 'Innovation', desc: 'New features and enhanced user experience.' },
                            { year: 'Today', title: 'Growing Strong', desc: 'Serving patients with verified providers across the country.' }
                        ].map((item, idx) => (
                            <div className="d-flex mb-4 position-relative" key={idx}>
                                <div className="me-3 d-flex flex-column align-items-center">
                                    <div className="rounded-circle bg-primary border border-2 border-white shadow-sm" style={{width: '12px', height: '12px', zIndex: 2}}></div>
                                    {idx !== 4 && <div className="bg-light" style={{width: '2px', flexGrow: 1, marginTop: '-5px', marginBottom: '-5px'}}></div>}
                                </div>
                                <div>
                                    <span className="badge bg-light text-primary mb-1">{item.year}</span>
                                    <h6 className="fw-bold mb-1">{item.title}</h6>
                                    <p className="text-muted small mb-0">{item.desc}</p>
                                </div>
                            </div>
                        ))}
                     </div>
                 </div>
            </div>
        </div>
    );
};

export default About;
